import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

// Importo o moment com a linguagem pt-br
require('moment');
require('moment/locale/pt-br');

class TrainingNoGradeStaffDisapprovedResult extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',        
      },
      redirect_url: false,
      loaded: 0,
      id: this.props.training_certification_staff_id,
      hours: '',
      confirmed: 0,
    };
    this.removeResult = this.removeResult.bind(this);
  }

  // LM
  componentWillReceiveProps(newProps) {
    if((this.state.loaded === 0 && typeof newProps.training_certification_staff_id !== 'undefined')){
      this.setState({
        hours: newProps.hours,
        confirmed: newProps.confirmed,
        status: newProps.status,
        status_str: newProps.status_str,
        id: newProps.training_certification_staff_id,
        loaded: 1,
      });
    }
  }
  // Fetch removendo resultado, para possibilitar edição
  removeResult(training_certification_staff_id){
    var confirm = window.confirm('Tem certeza que deseja editar nota?');
    if (confirm) {
      this.props.handleAlert('', '', 'open');
      var datasave = {
        id: training_certification_staff_id,
      };
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/treinamento/certificado/colaborador/editar/nota', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          self.props.updateData(responseJson);
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }

  render() {
    var self = this;
    return (
      <div>
        <RequestApi ref={'request_api'} />
        <table className="table">
          <thead>
            <tr>
              <th className="text-center">Horas</th>
              <th className="text-center">Ações</th>
              <th className="text-center">Status</th>
            </tr>
          </thead>
          <tbody>
            <tr>
                <td>
                  {this.state.hours}
                </td>
                <td>
                  <button className="btn btn-sm btn-success button-inline" value={self.state.id} onClick={() => self.removeResult(self.state.id)}><i className="fa fa-fw fa-refresh"></i> Editar nota</button>
                </td>
                <td>
                  {
                    (this.state.confirmed === 0) ?
                      <span className="label label-warning">Faltante</span>
                    :
                      <span className="label label-danger">{this.state.status_str}</span>
                  }
                </td>
            </tr>
          </tbody>
        </table>

      </div>
    );
  }
}

export default TrainingNoGradeStaffDisapprovedResult;



// WEBPACK FOOTER //
// ./src/Components/Trainings/Elements/TrainingNoGradeStaffDisapprovedResult.js